<!-- 命令管理 -->
<template>
  <div>
    <div class="table-fixed">
      <a-table ref="table" size="middle" :scroll="{x: 'max-content'}" bordered rowKey="id" :columns="columns"
        :dataSource="dataSource" :pagination="ipagination" :loading="loading" class="j-table-force-nowrap"
        :components="drag(columns)" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="record.meterType=='80'?handleDetail(record):handleDetails(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <partCommand-old-modal ref="modalOldForm" @ok="modalOldForm"></partCommand-old-modal>
    <partCommand-modal ref="modalForm" @ok="modalFormOk"></partCommand-modal>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {
    mixinDevice
  } from '@/utils/mixin'
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin'
  import {
    AreaChoosetMixin
  } from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import {
    getAction,
    httpAction
  } from '@/api/manage'
  import moment from 'moment'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil'
  import Vue from 'vue'
  import TableDragResize from '@/mixins/TableDragResize'
  import PartCommandOldModal from '@/views/part/modules/PartCommandOldModal.vue'
  import PartCommandModal from '@/views/part/modules/PartCommandModal'
  import {dataFlagObj,reportStatusObj} from '@/utils/constants/protocolConstant'
  import {isUndefined} from'@/utils/validate'
  export default {
    name: 'CommandManagement',
    mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
    components: {
      PartCommandOldModal,
      PartCommandModal
    },
    props: {
      id: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        description: 'CommandManagement管理页面',
        collapsed: false,
        url: {
          list: "/jeecg-charge/meter/command/list",
        },
        beginDate: null,
        endDate: null,
        endOpen: false,
        date: [],
      }
    },
    watch: {
      id(val) {
        if (val) {
          this.loadData();
        }
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [{
          title: this.$t('用户编号'),
          align: "center",
          dataIndex: 'userId'
        }, {
          title: this.$t('用户姓名'),
          align: "center",
          dataIndex: 'userName'
        }, {
          title: this.$t('表编号'),
          align: "center",
          dataIndex: 'meterId'
        }, {
          title: this.$t('表安装地址'),
          align: "center",
          dataIndex: 'userMeterAddr'
        }, {
          title: this.$t('表类型'),
          align: "center",
          dataIndex: 'mtName',
        }, {
          title: this.$t('命令标识'),
          align: "center",
          dataIndex: 'cmd',
          customRender: (text) => {
            return this.$t(dataFlagObj[text])
          }
        }, {
          title: this.$t('命令ID'),
          align: "center",
          dataIndex: 'commandId'
        }, {
          title: this.$t('通讯状态'),
          align: "center",
          dataIndex: 'status',
          customRender: (t, r, index) => {
            let data = reportStatusObj
            if (isUndefined(data[t])) {
              return this.$t('其他')
            }
            return this.$t(data[t])
          }
        }, {
          title: this.$t('发送时间'),
          align: "center",
          dataIndex: 'sendTime'
        }, {
          title: this.$t('接收回应时间'),
          align: "center",
          dataIndex: 'receiveTime'
        }, {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: "center",
          fixed: "right",
          width: 70,
          scopedSlots: {
            customRender: 'action'
          }
        }]
      }
    },
    methods: {
      loadData() {
        var params = this.getQueryParams(); //查询条件
        params.userId = this.id;
        getAction(this.url.list, params).then(res => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      handleDetails(record) {
        this.$refs.modalOldForm.edit(record);
        this.$refs.modalOldForm.title = this.$t('详情');
        this.$refs.modalOldForm.disableSubmit = true;
      },
      handleDetail(record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = this.$t('详情');
        this.$refs.modalForm.disableSubmit = true;
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>